





































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { ICompany } from "@/models/companies";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";

@Component
export default class UCompany extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public company!: ICompany;
  @Prop({ default: false })
  public isReadonly!: boolean;
  @Prop({ default: false })
  public isStaged!: boolean;
  @Prop({ default: true })
  public showName!: boolean;
  @Prop({ default: false })
  public showDefault!: boolean;
  @Prop({ default: true })
  public showAddress!: boolean;
  @Prop({ default: true })
  public isMultiline!: boolean;

  // Data
  public dataModule: string = DataModules.CLIENTS_COMPANIES;

  // Methods

  public editCompany() {
    return this.$store.dispatch(`data/${this.dataModule}/openEditModal`, {
      company: this.company,
      config: {
        events: {
          success: () => {
            this.$emit("edit");
          }
        }
      }
    });
  }

  public makeDefault() {
    return this.$store
      .dispatch(`data/${this.dataModule}/makeDefault`, {
        company: this.company
      })
      .then((onSuccess?: boolean) => {
        if (onSuccess) this.$emit("refresh");
      });
  }

  public deleteCompany() {
    return this.$store.dispatch(`data/${this.dataModule}/confirmDelete`, {
      company: this.company,
      onConfirm: () => {
        this.$emit("refresh");
        this.$emit("delete");
      }
    });
  }
}
